import React, { ReactElement } from 'react';
import OverviewLayoutAside from './OverviewLayoutAside';
import OverviewLayoutSection, { OverviewLayoutSectionProps } from './OverviewLayoutSection';

interface UseSections {
  aside?: React.ReactElement;
  sections: React.ReactElement[];
}

export const useSections = (children: React.ReactNode): UseSections => {
  const sections: React.ReactElement<OverviewLayoutSectionProps>[] = [];
  let aside: React.ReactElement | undefined;

  React.Children.forEach(children, (child) => {
    if (React.isValidElement(child)) {
      if (child.type === OverviewLayoutSection) {
        sections.push(child as ReactElement<OverviewLayoutSectionProps>);
        return;
      }

      if (child.type === OverviewLayoutAside) {
        aside = child;
        return;
      }

      throw new Error('OverviewLayout children should be of type OverviewLayoutSection.');
    }
  });

  return {
    aside,
    sections,
  };
};
